import { Button, Icon } from '../components/ui';
import React, { createContext, useCallback, useContext, useLayoutEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { BrandSplash } from '../components/BrandMark';

const ThemeContext = createContext(null);
const readTheme = key => {
  try { return localStorage.getItem(key) === 'dark' ? 'dark' : 'light'; }
  catch { return 'light'; }
};

export function ThemeProvider({ children }) {
  const { user, loading } = useAuth();
  const key = `rnd:theme:${user?.id || 'guest'}`;
  const [selection, setSelection] = useState(() => ({ key, value: readTheme(key) }));
  const theme = selection.key === key ? selection.value : readTheme(key);
  useLayoutEffect(() => {
    document.documentElement.dataset.theme = theme;
    document.documentElement.style.colorScheme = theme;
    const dark = theme === 'dark';
    const svgIcon = document.getElementById('app-favicon-svg');
    const icoIcon = document.getElementById('app-favicon-ico');
    const themeColor = document.getElementById('app-theme-color');
    const mark = dark ? 'mark.svg' : 'mark-light.svg';
    const fallback = dark ? 'brand/favicon-dark.ico' : 'favicon.ico';
    if (svgIcon) svgIcon.setAttribute('href', `${process.env.PUBLIC_URL}/brand/${mark}?v=compass-2`);
    if (icoIcon) icoIcon.setAttribute('href', `${process.env.PUBLIC_URL}/${fallback}?v=compass-2`);
    if (themeColor) themeColor.setAttribute('content', dark ? '#191d30' : '#ffffff');
  }, [theme]);
  const setTheme = useCallback(value => {
    if (value !== 'light' && value !== 'dark') return;
    setSelection({ key, value });
    try { localStorage.setItem(key, value); } catch { /* Theme still works when storage is unavailable. */ }
    console.info('ui.theme_changed', { theme: value });
  }, [key]);
  return <ThemeContext.Provider value={{ theme, setTheme }}>
    {loading ? <BrandSplash /> : children}
  </ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);

export function ThemeToggle({ compact = false }) {
  const { theme, setTheme } = useTheme();
  const label = theme === 'light' ? 'Тёмная тема' : 'Светлая тема';
  return <Button variant="ghost" className="theme-toggle" aria-label={label} title={label}
    onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}>
    <Icon name={theme === 'light' ? 'moon' : 'sun'} />{!compact && <span>{label}</span>}
  </Button>;
}
